export interface KeyValueItem {
  id: string;
  key: string;
  value: string;
}

export const newKeyValueItem = (
  key = "",
  value = "",
): KeyValueItem => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  key,
  value,
});

export const itemsFromPairs = (
  pairs: { key: string; value: string }[],
): KeyValueItem[] => pairs.map((p) => newKeyValueItem(p.key, p.value));
